<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Test Sets",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Multiselect,
  },
  data() {
    return {
      title: "Test Sets Considered",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Test Sets",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "test",
          label: "Set Name",
          sortable: true,
        },
        {
          key: "priority",
          label: "Position",
          sortable: true,
        },
        {
          key: "class_details.name",
          label: "Class",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        test: "",
        year: "",
        priority: "",
        classes: [],
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        test: "",
        year: "",
        id: "",
        priority: "",
      },
      nameError: "",
      yearError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("coursework", ["AllSets", "TestConsideration", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("classes", ["AllClasses"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.TestConsideration ? this.TestConsideration.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.TestConsideration ? this.TestConsideration.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsiderations: "coursework/fetchSetConsiderations",
      FetchSets: "coursework/fetchSets",
      AddSet: "coursework/addSetConsideration",
      EditSet: "coursework/editSetConsideration",
      DeleteSet: "coursework/deleteSetConsideration",
      FetchClasses: "classes/fetchClasses",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.TestConsideration
        ? this.TestConsideration.length
        : 1;
      this.currentPage = 1;
    },

    setYear() {
      const dates = new Date();
      let currentYear = dates.getFullYear();
      this.data.year = currentYear;
    },

    resetError() {
      this.nameError = "";
      this.yearError = "";
    },

    resetAddModal() {
      this.data.test = "";
      this.data.year = "";
      this.data.priority = "";
      this.resetError();
      this.setYear();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.test = "";
      this.editdata.year = "";
      this.editdata.priority = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    addSet(modal) {
      if (this.data.test == "") {
        this.nameError = "Set field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.year == "") {
        this.yearError = "Year field can't be empty";
        return;
      } else {
        this.yearError = "";
      }
      this.modal = modal;
      this.AddSet(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.test.name;
    },
    deleteSet(modal) {
      this.modal = modal;
      this.DeleteSet(this.deletedata);
      this.closeModal(modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSets();
    this.FetchConsiderations();
    this.FetchClasses();
    this.setYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_considered_tests')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Test Sets Considered
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-set-modal
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_considered_tests')
                    )
                  "
                  class="btn btn-sm btn-primary float-end"
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="TestConsideration"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(test)="data">
                  {{ data.item.test.name + " (" + data.item.test.short + ")" }}
                </template>
                <template #cell(priority)="data">
                  {{
                    data.item.priority == 1
                      ? "First"
                      : data.item.priority == 2
                      ? "Second"
                      : "Third"
                  }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-set-modal
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('delete_considered_tests')
                      )
                    "
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-set-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_considered_tests')
          )
        "
      >
        <template #modal-title> Add New Set to be Considered </template>
        <div class="row d-flex">
          <div class="col-md-10 mx-auto">
            <div class="form-group mb-2">
              <label>Test Set <small class="text-danger">*</small></label>
              <div class="input-group">
                <model-list-select
                  :list="AllSets ? AllSets : []"
                  v-model="data.test"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Set"
                  @input="resetError()"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="nameError">
                <em>{{ nameError }}</em>
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Year <small class="text-danger">*</small></label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Year"
                  class="form-control"
                  @input="resetError()"
                  v-model="data.year"
                />
              </div>
              <div class="text-danger" v-if="yearError">
                <em>{{ yearError }}</em>
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Class(es) <small class="text-danger">*</small></label>
              <div class="input-group">
                <multiselect
                  v-model="data.classes"
                  :height="300"
                  :options="AllClasses ? AllClasses : []"
                  :multiple="true"
                  :taggable="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  tag-placeholder="Add a class"
                  placeholder="Search or add a class"
                  label="name"
                  track-by="id"
                  :preselect-first="false"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen"
                      >{{ values.length }} options selected</span
                    ></template
                  >
                </multiselect>
              </div>
              <div class="text-danger" v-if="classError">
                <em>{{ classError }}</em>
              </div>
            </div>
            <div class="form-group mb-3">
              <label
                >Select Priority <br /><small class="text-primary"
                  >(Select position on the report e.g 'first' will make it
                  appear in the first column)</small
                >
                <small class="text-danger">*</small></label
              >
              <select required v-model="data.priority" class="form-control">
                <option selected value="" disabled>Select Priority</option>
                <option value="1">First</option>
                <option value="2">Second</option>
                <option value="3">Third</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addSet('add-set-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-set-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_considered_tests')
          )
        "
      >
        <template #modal-title> Edit Set {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Test Set <small class="text-danger">*</small></label>
          <div class="input-group">
            <model-list-select
              :list="AllSets ? AllSets : []"
              v-model="editdata.test"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Set"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Year <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Year"
              class="form-control"
              @input="resetError()"
              v-model="editdata.year"
            />
          </div>
          <div class="text-danger" v-if="yearError">
            <em>{{ yearError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-success"
            @click="editSet('edit-set-modal')"
          >
            <b-spinner
              v-if="SaveStatus"
              variant="primary"
              small
              label="Saving"
            ></b-spinner>
            <i class="fa fa-check"></i>
            Save Changes
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete set starts -->
      <b-modal
        id="delete-set-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_considered_tests')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Test Set {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Test Set From considered sets? Click Confirm
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteSet('delete-set-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
